// SHWCare LegitScript certification seal (BestRx) — OFFICIAL embed.
//
// Official LegitScript seal issued for SHWCare (shwcare.com), served from the
// LegitScript CDN and linking to SHWCare's validation page. Not scaled via CSS
// (native 73x79). Caption makes clear SHWCare — not BestRx — is certified.
//
// Seal image : https://static.legitscript.com/seals/48397852.png
// Validation : https://www.legitscript.com/websites/?checker_keywords=shwcare.com
// Seal ID    : 48397852 · Certified entity: SHWCare (shwcare.com)
const SEAL_SRC = "https://static.legitscript.com/seals/48397852.png";
const VERIFY_URL = "https://www.legitscript.com/websites/?checker_keywords=shwcare.com";

export default function ShwcareLegitScript({ brand = "BestRx" }) {
  return (
    <div data-testid="shwcare-legitscript" className="inline-flex items-center gap-3 max-w-[360px]">
      <a
        href={VERIFY_URL}
        target="_blank"
        rel="noopener noreferrer nofollow"
        title="Verify LegitScript Approval for www.shwcare.com"
        data-testid="shwcare-legitscript-verify"
        className="inline-block leading-none shrink-0"
      >
        {/* Native 73x79 — do not scale via CSS per LegitScript guidance */}
        <img src={SEAL_SRC} alt="Verify Approval for www.shwcare.com" width="73" height="79" />
      </a>
      <span className="text-[11.5px] text-white/60 leading-snug">
        <strong className="font-bold text-white/90">SHWCare is LegitScript Certified.</strong>{" "}
        {brand} members transition to SHWCare for clinical care.
      </span>
    </div>
  );
}
